export enum MAIN_PAGES {
    default = '',
    users = 'users',
    settings = 'settings',
    analytics = 'analytics',
    notifications = 'notifications',
    plumes = 'plumes',
    dashboard = 'dashboard',
    networks = 'networks',
    indoor = 'indoor',
    reports = 'reports',
    forecast = 'forecast',
    global = 'global',
    indoorWidget = 'indoor-widget',
}
